import React from 'react'
import { createRoot } from 'react-dom/client'

import Iframe from '../components/Iframe'


// `observeMutations()` calls us again on the same element whenever its
// `data-id` changes, so the root has to outlive a single call. Creating one
// per call clears the container and leaves the previous root mounted, which
// tears down the iframe instead of letting React update it.
const roots = new WeakMap()


export default function renderIntoElement(element) {
  const id = element.getAttribute('data-id')

  if ( !id ) {
    console.error('[Termly] Policy embed element %o is missing a `data-id` attribute', element)
    return
  }

  const root = roots.get(element) || createRoot(element)

  roots.set(element, root)

  root.render(
    <Iframe
      id={ id }
    />,
  )
}
